'use client';

import SharedContent from './_shared/SharedContent';

const Content = () => {
  return (
    <section data-cy="eu-declaration-of-conformity-gen-3">
      <SharedContent />
    </section>
  );
};

export default Content;
